import { createSlice } from '@reduxjs/toolkit';
const SLICE_NAME = 'offerModalSlice';

export const offerModalSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        isOpen: false,
    },
    reducers: {
        toggleOfferModal(state) {
            state.isOpen = !state.isOpen;
        },
    },
});

export const { toggleOfferModal } = offerModalSlice.actions;

export const offerModalStateSelector = state => state.offerModal.isOpen;

export const offerModal = offerModalSlice.reducer;
